import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CloudProvider } from 'src/app/core/models/cloudProvider';
import { DeploymentService } from 'src/app/core/services/deployment.service';
import { EnvironmentService } from 'src/app/core/services/environment.service';
import { AddDeploymentComponent } from '../add-deployment/add-deployment.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CloudProviderTypes, CloudTypes } from 'src/app/core/models/globals';
import { AddKvmDeploymentComponent } from '../add-deployment/add-kvm-deployment/add-kvm-deployment.component';
import { StorageService } from 'src/app/core/services/storage.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { UserRoleNames } from 'src/app/core/models/users';

@Component({
  selector: 'app-new-deployment',
  templateUrl: './new-deployment.component.html',
  styleUrls: ['./new-deployment.component.scss'],
})
export class NewDeploymentComponent implements OnInit {
  cloudProviders: CloudProvider[];
  providerImagePath: string =
    this.environmentService.envVariables.providerImagePath;
  infra = localStorage.getItem("cloudProvider") || "hpc";
  role = this.authenticationService.getRole() || "";

  constructor(
    private depService: DeploymentService,
    private environmentService: EnvironmentService,
    private dialog: MatDialog,
    private snackbar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private navService: NavigationService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.depService.getAllCloudProviders().subscribe((data) => {
      this.cloudProviders = <CloudProvider[]>JSON.parse(JSON.stringify(data));
      if(this.cloudProviders && this.cloudProviders.length > 0){
        if(this.infra){
          this.cloudProviders = this.cloudProviders.filter((provider) => provider.providerDeploymentType.toLowerCase() == this.infra);
        }
      }
      this.cloudProviders.forEach((provider) => {
        provider.providerIconFileName = `${this.providerImagePath}${provider.providerIconFileName}`;
      });
    });
  }

  addDeployment(provider: CloudProvider) {
    if(this.role != UserRoleNames.GlobalAdmin){
      return;
    }
    if(provider.providerUseStaticForm == false){
      const dialogRef = this.dialog.open(AddDeploymentComponent, {
        width: '60%',
        autoFocus: true,
        disableClose: true,
        data: { provider },
      });
      dialogRef.afterClosed().subscribe(async (res) => {
        if (res) {
          this.snackbar.open(
            'Deployment Created Successfully, Wait For Some Time To be Active or Refresh Page.',
            'Ok',
            {
              duration: 3000,
            }
          );
          this.router.navigate(["../"], { relativeTo: this.route });
        }
      });
    }
    else{
      switch(provider.providerName){
        case CloudTypes.AWS:
          break;

        case CloudTypes.Google:
          break;

        case CloudTypes.KVM:
          const dialogRef = this.dialog.open(AddKvmDeploymentComponent, {
            width: '35%',
            autoFocus: true,
            disableClose: true,
            data: { provider },
          });
          dialogRef.afterClosed().subscribe(async (res) => {
            if (res) {
              this.snackbar.open(
                'Deployment Created Successfully, Wait For Some Time To be Active or Refresh Page.',
                'Ok',
                {
                  duration: 3000,
                }
              );
              let depName = JSON.parse(JSON.stringify(res))[0].depValue;
              let storageAccountName = JSON.parse(JSON.stringify(res))[0].depValue;
              this.router.navigate([
                "Home",
                CloudTypes.KVM,
                depName
              ])
              this.navService.sendChildData(depName);
              this.storageService.sendActiveStorageName(storageAccountName)
            }
          });
          break;

        case CloudTypes.MicrosoftAzure:
          break;

        case CloudTypes.OnPremise:
          break;

        case CloudTypes.Oracle:
          break;

        default:
          break;
      }
    }
  }
}
